module.exports = __webpack_public_path__ + "static/media/driver.fa38376e.svg";